GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.numFsRemaining = 0;
  this.fsCount = 0;

  this.superFreespinsCostMultiplier = 300;
  this.freeSpinsCostMultiplier = 100;
  this.superFreespinsActive = false;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;

  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;

  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inEncore = false;
  this._inBuyABonus = false;
  this._inBuyASuperBonus = false;
  this._rtp = 0;
  this._baseGameWinnings = 0;
  this._totalWinnings = 0;
  this._finalBaseWinnings = 0;
  this._finalFsWinnings = 0;

  //	this._coinValue = 100; // because of paytable

  this._baseOutcome = {
    spins: [],
  };
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    "ReflexGaming",
    "LEFT_TOP",
    [],
    "TOP_LEFT"
  );
};

GatiServer.prototype.initPlayerConnect = async function (
  provider,
  pcUrl,
  boostPosition,
  gameFeatures,
  replayBackPosition,
  callbackSuccess
) {
  await $.getScript(pcUrl || "WRONG-PC-URL");
  //await $.getScript("https://dev.game.lan/pc/partnerconnect.js");
  let slot = new PartnerConnect.SlotGame();
  this.subscribeEvents(slot);
  let loadData = await slot.load({
    companyName: provider,
    boost: { buttonPosition: boostPosition },
    gameFeatures: gameFeatures,
    pcFeatures: { backButtonPosition: replayBackPosition },
    replayReload: true,
  });
  this._license = loadData.customParameters.license;
  this._translationsShared = JSON.parse(
    JSON.stringify(loadData.translations.shared)
  );
  this._translationsGame = JSON.parse(
    JSON.stringify(loadData.translations.game)
  );
  this._translations = Object.assign(
    loadData.translations.shared,
    loadData.translations.game
  );
  this._allowAutoplay = !loadData.settings.isAutoSpinsDisabled;
  this._allowGamble = !loadData.settings.isGambleFeatureDisabled;
  this._allowUpstake = !loadData.settings.isGoldenBetDisabled;
  this._buyBonusAllowed = !loadData.settings.isBuyBonusDisabled;
  this._superBuyBonusAllowed = !loadData.settings.isBuyBonusDisabled;
  this._allowGameRules = loadData.settings.menuVisibility.isMenuRulesVisible;
  this._slotGame = slot;
  this._previousWagers = loadData.wagers;
  this._inRewatchMode = loadData.mode === "REWATCH";
  this._inReplayMode = loadData.mode === "REPLAY";
  this._stake = loadData.settings.defaultBet * 100;
  this.setDefaultBet(this._stake);
  gdk.setMinGameTime(loadData.settings.minimalSpinningTime);
  this.showPlatformOverlays(true);
  let self = this;
  this.getGameConfig(loadData, function () {
    self.loadAssetTable(callbackSuccess);
  });
};

GatiServerGame.prototype.getSupplierForceName = function () {
  return "gati_" + +this._rtp * 1000;
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    if (
      sc.isMaxStake() &&
      !this._inReplayMode &&
      !this._inRewatchMode &&
      !this._isPrePaidGame &&
      !isStakeLower
    ) {
      this._slotGame
        .uiComponents()
        .clickActionHandler()
        .maximumBetWarning(this._stake / 100);
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.addGameConfigToQueueBase(loadData);
  let message = this._messageQueue[0];
  // message.buyBonusCost = 100;

  message.buyBonusCostSuperFreespins = this.superFreespinsCostMultiplier;
  message.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;

  gdk.addConfigValue(
    "AllowBuyBonus",
    message.slotConfig.gameModes["BONUS_BUY"] ? true : false
  );

  message.slotConfig.coins = 20; // purely paytable

  this._rtp = message.slotConfig.rtp;

  let stopDistances2and5 = [17, 23, 29, 35, 41];
  let stopDistances3 = [30, 36, 42, 48, 54];
  let stopDistances5 = [49, 61, 73, 85, 97];
  switch (this._license) {
    case "uk":
      message.stopDistances = stopDistances2and5;
      break;
    case "UKGCRtsTest":
      message.stopDistances = stopDistances2and5;
      break;
    case "bgc":
      message.stopDistances = stopDistances2and5;
      break;
    case "es":
      message.stopDistances = stopDistances3;
      break;
    case "se":
      message.stopDistances = stopDistances3;
      break;
    case "dk":
      message.stopDistances = stopDistances3;
      break;
    case "cz":
      message.stopDistances = stopDistances2and5;
      break;
    case "co":
      message.stopDistances = stopDistances3;
      break;
    case "agcc":
      message.stopDistances = stopDistances2and5;
      break;
    case "de":
      message.stopDistances = stopDistances5;
      break;
    default:
      message.stopDistances = stopDistances3;
      break;
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === "LUCKYBET_BUY") {
      this._inEncore = true;
      this._meta = {
        name: "encore",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "BONUS_BUY") {
      this.superFreespinsActive = false;
      this._inBuyABonus = true;
      this._meta = {
        name: "buyABonus",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "SUPER_BONUS_BUY") {
      this.superFreespinsActive = true;
      this._inBuyASuperBonus = true;
      this._meta = {
        name: "buyASuperBonus",
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServer.prototype.isGameModeSuperBonusBuy = function (mode) {
  return mode === "SUPER_BONUS_BUY";
};

GatiServer.prototype.parseGameModes = function (loadData, defaultNumLines) {
  let res = {};

  for (let mode in loadData.settings.modes) {
    if (loadData.settings.modes.hasOwnProperty(mode)) {

      if (this.isGameModeBonusBuy(mode) && !this._buyBonusAllowed) continue;
       if (this.isGameModeSuperBonusBuy(mode) && !this._superBuyBonusAllowed) continue;

      let modeData = loadData.settings.modes[mode];
      let totalStakes = this.parseDenoms(modeData.coins, this._coinValue);
      res[mode] = {
        coinSizes: totalStakes.map(function (x) {
          return x / defaultNumLines;
        }),
        defaultAmountPerLine:
          this.parseDefaultBet(modeData.defaultCoin, this._coinValue) /
          defaultNumLines,
        coinsPerBet: modeData.coinsPerBet,
      };
    }
  }

  res.default = JSON.parse(JSON.stringify(res.BASIC));
  return res;
};

GatiServer.prototype.parseDenoms = function (denoms, denomValue) {
  var arrayStr = denoms;

  if (arrayStr[0] === "NaN") {
    arrayStr = "[]";
  } else {
    arrayStr = "[" + arrayStr + "]";
  }

  var coinSizes = JSON.parse(arrayStr);
  return coinSizes.map(function (x) {
    return Number(x * 100 * denomValue).toFixed(0);
  });
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inEncore = stakeData.metaData.encore;
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this.superFreespinsActive =
    stakeData.metaData.superFreespinsActive !== undefined
      ? stakeData.metaData.superFreespinsActive
      : false;
  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 100;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._inEncore) {
    request.coins = 150;
    this._coinValue = 100; // has to be whole number
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue; // should be 0.1 on a base stake of £1, so £1.50 for lucky bet
    request.cmd = "LUCKYBET_BUY";
  } else if (this._inBuyABonus) {
    baseStake =
      stakeController.getBaseStake(
        this.superFreespinsActive ? "SUPER_BONUS_BUY" : "BONUS_BUY"
      ) / 100;
    request.amount =
      baseStake *
      (this.superFreespinsActive
        ? this.superFreespinsCostMultiplier
        : this.freeSpinsCostMultiplier);
    request.coins = this.superFreespinsActive ? 40000 : 10000;
    request.coin = baseStake / this._coinValue;
    request.cmd = this.superFreespinsActive ? "SUPER_BONUS_BUY" : "BONUS_BUY";
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.spin;
  let spinData = data.spin.cascades;
  if (!this.validateResponse(spinEvent)) return;

  let leftMultiplierInc = 0;
  let rightMultiplierInc = 0;
  let leftMultiplierFinal = 0;
  let rightMultiplierFinal = 0;

  let isCapped = data.isCapped;

  let length = spinData.length - 1;

  if (isCapped) {
    length = spinData.length;
  }

  let isNotFinal = true;

  this.addSpinDataToQueue(spinEvent);

  let totalWinInBase = 0;
  let extraLives = 0;
  totalWinInBase += data.spin.winAmount;

  this._baseGameWinnings += data.spin.winAmount;

  for (let i = 0; i < length; ++i) {
    let isNotFinal = spinData[i + 1];

    let winningLineEvent = spinData[i];

    if (isNotFinal) {
      let poppedSymbols = spinData[i + 1].removedCoords;

      if (spinData[i + 1].wildAddedCoord) {
        let lowestRow = spinData[i + 1].wildAddedCoord.row;
        var wildReel = spinData[i + 1].wildAddedCoord.reel;

        poppedSymbols.forEach((symbol) => {
          if (symbol.reel === wildReel) {
            if (symbol.row === lowestRow + 1) {
              lowestRow = symbol.row;
              spinData[i + 1].wildAddedCoord.row = symbol.row;
            }
          }
        });
      }

      extraLives = spinData[i + 1].extraLivesFinal;

      if (spinData[i].tntModifier.isAwarded) {
        let finalStopWindow = JSON.parse(
          JSON.stringify(spinEvent.cascades[i].finalStopWindow.reelList)
        );
        this.addModifierEventToQueue(
          spinEvent.cascades[i].tntModifier,
          finalStopWindow,
          winningLineEvent
        );
      }

      /**
       * SpecialReward for wild modifiers
       * Types are: double wild, multiplier boost,wild stack,extra life
       */
      let specialReward;
      let message = {};

      trailCount = spinData[i + 1].trailFinal;

      if (spinData[i + 1].specialReward !== null) {
        specialReward = spinData[i + 1].specialReward;
      } else {
        specialReward = null;
      }

      let extraWildCoord = null;

      if (specialReward?.type == "DoubleWild") {
        message.DoubleWildCoord = specialReward.wildAddedCoord;
        extraWildCoord = [specialReward.wildAddedCoord];

        let lowestRow = extraWildCoord.row;
        var doubleWildReel = extraWildCoord.reel;

        poppedSymbols.forEach((symbol) => {
          if (symbol.reel === doubleWildReel) {
            if (symbol.row > lowestRow) {
              lowestRow = symbol.row;
              extraWildCoord.row = symbol.row;
            }
          }
        });
      } else if (specialReward?.type == "MultiplierBoost") {
        message.leftMultiplierInitial = specialReward.leftMultiplierInitial;
        message.rightMultiplierInitial = specialReward.rightMultiplierInitial;
        message.leftMultiplierFinal = specialReward.leftMultiplierFinal;
        message.rightMultiplierFinal = specialReward.rightMultiplierFinal;
      } else if (specialReward?.type == "WildStack") {
        var reel = spinData[i + 1].wildAddedCoord.reel;
        extraWildCoord = [];

        for (let j = 0; j < 3; j++) {
          extraWildCoord.push({ reel: reel, row: j });
        }
      }

      message = specialReward;

      leftMultiplierInc = spinData[i + 1].leftMultiplierIncrease;
      rightMultiplierInc = spinData[i + 1].rightMultiplierIncrease;
      leftMultiplierFinal = spinData[i + 1].leftMultiplierFinal;
      rightMultiplierFinal = spinData[i + 1].rightMultiplierFinal;

      this.addPopsToQueue(
        winningLineEvent,
        spinData[i].winAmount,
        leftMultiplierInc,
        rightMultiplierInc,
        leftMultiplierFinal,
        rightMultiplierFinal,
        isCapped,
        false
      );
      this.addDropsToQueue(
        spinData[i + 1].finalStopWindow.reelList,
        spinData[i + 1].wildAddedCoord,
        poppedSymbols,
        message,
        trailCount,
        leftMultiplierInc,
        rightMultiplierInc,
        leftMultiplierFinal,
        rightMultiplierFinal,
        extraLives,
        extraWildCoord
      );
    } else {
      this.addPopsToQueue(
        winningLineEvent,
        spinData[i].winAmount,
        leftMultiplierInc,
        rightMultiplierInc,
        leftMultiplierFinal,
        rightMultiplierFinal,
        isCapped,
        true
      );
    }
  }

  /**
   * Tnt modifier in cascades
   */
  for (let i = 0; i < this._messageQueue.length; i++) {
    if (this._messageQueue[i].tntModifier !== undefined) {
      if (this._messageQueue[i].tntModifier.isAwarded) {
        let fakeSymbols = this._messageQueue[i].tntModifier.replacementSymbols;
        let fakeSymbolsLength =
          this._messageQueue[i].tntModifier.replacementSymbols.length;
        let reel = this._messageQueue[i].tntModifier.reelToHide;
        let dropMessage = this._messageQueue[i - 3]; // get the drop modifier event

        for (let j = 0; j < fakeSymbolsLength; j++) {
          for (let j = 0; j < fakeSymbolsLength; j++) {
            if (dropMessage.window !== undefined) {
              dropMessage.window[reel][j]._id = fakeSymbols[j];
            } else if (dropMessage.resultPanel.reelList !== undefined) {
              dropMessage.resultPanel.reelList[reel].symbols[j].value =
                fakeSymbols[j];
            }
          }
        }
      }
    }
  }

  this.addPopDropsOverToQueue(totalWinInBase);

  return totalWinInBase;
};

// GatiServerGame.prototype.addMultiplerToQueue = function(leftMultiplier, rightMultiplier){
// 	var message = {};
// 	message.type = "game:MultiplierEvent";

// 	message.leftMultiplierIncrease = leftMultiplier;
// 	message.rightMultiplierIncrease= rightMultiplier;

// 	// message.currentLeftMultiplier = leftMultiplier ;
// 	// message.nextLextMultiplier = leftMultiplier * 2 ;

// 	// message.currentRightMultiplier = rightMultiplier ;
// 	// message.nextRightMultiplier = rightMultiplier * 2 ;

// 	this._messageQueue.push(message);
// };

/**
 * 
 * The free spins part is essentially identical to the baseGame part
except that the 'spins' property is now an array of spins.

The data contained in each element of the spins array is identical
to that described in the baseGamePart for the 'spin' property.

{
    "type": "freeSpins",
    "winAmount": 6560,
    "spins": []
}
 */
GatiServerGame.prototype.getSpinDataFS = function (cb, finalData) {
  let data = this.freeSpins[this.fsCount++];
  --this.numFsRemaining;
  let spinEvent = data;
  //this.addMultiplerToQueue(1, 1);
  this.addSpinDataToQueue(spinEvent);
  //let extraLivesActivated = false

  let extraLives = 0;
  let spinWin = 0;
  spinWin += data.winAmount;

  let isCapped = data.isCapped;

  let length = data.cascades.length - 1;

  if (isCapped) {
    length = data.cascades.length;
  }

  let isNotFinal = true;

  for (let i = 0; i < length; ++i) {
    //If no win on first drop in, the cascade data array will not be longer then 1
    isNotFinal = data.cascades[i + 1];

    let winningLineEvent = data.cascades[i];

    if (isNotFinal) {
      let poppedSymbols = data.cascades[i + 1].removedCoords;
      trailCount = data.cascades[i + 1].trailFinal;

      if (data.cascades[i + 1].wildAddedCoord) {
        let lowestRow = data.cascades[i + 1].wildAddedCoord.row;
        var wildReel = data.cascades[i + 1].wildAddedCoord.reel;

        poppedSymbols.forEach((symbol) => {
          if (symbol.reel === wildReel) {
            if (symbol.row === lowestRow + 1) {
              lowestRow = symbol.row;
              data.cascades[i + 1].wildAddedCoord.row = symbol.row;
            }
          }
        });
      }

      if (data.cascades[i].tntModifier.isAwarded) {
        let finalStopWindow = JSON.parse(
          JSON.stringify(spinEvent.cascades[i].finalStopWindow.reelList)
        );

        this.addModifierEventToQueue(
          spinEvent.cascades[i].tntModifier,
          finalStopWindow,
          winningLineEvent
        );
      }

      /**
       * SpecialReward for wild modifiers
       * Types are: double wild, multiplier boost,wild stack,extra life
       */
      let specialReward;
      let message = {};

      if (data.cascades[i + 1].specialReward !== null) {
        specialReward = data.cascades[i + 1].specialReward;
      } else {
        specialReward = [];
      }

      extraLives = data.cascades[i + 1].extraLivesFinal;

      let extraWildCoord = null;

      if (specialReward.type == "DoubleWild") {
        message.DoubleWildCoord = specialReward.wildAddedCoord;
        extraWildCoord = [specialReward.wildAddedCoord];

        let lowestRow = extraWildCoord.row;
        var doubleWildReel = extraWildCoord.reel;

        poppedSymbols.forEach((symbol) => {
          if (symbol.reel === doubleWildReel) {
            if (symbol.row > lowestRow) {
              lowestRow = symbol.row;
              extraWildCoord.row = symbol.row;
            }
          }
        });
      } else if (specialReward.type == "MultiplierBoost") {
        message.leftMultiplierInitial = specialReward.leftMultiplierInitial;
        message.rightMultiplierInitial = specialReward.rightMultiplierInitial;
        message.leftMultiplierFinal = specialReward.leftMultiplierFinal;
        message.rightMultiplierFinal = specialReward.rightMultiplierFinal;
      } else if (specialReward.type == "WildStack") {
        var reel = data.cascades[i + 1].wildAddedCoord.reel;
        extraWildCoord = [];

        for (let j = 0; j < 3; j++) {
          extraWildCoord.push({ reel: reel, row: j });
        }
      }

      leftMultiplierInc = data.cascades[i + 1].leftMultiplierIncrease;
      rightMultiplierInc = data.cascades[i + 1].rightMultiplierIncrease;
      leftMultiplierFinal = data.cascades[i + 1].leftMultiplierFinal;
      rightMultiplierFinal = data.cascades[i + 1].rightMultiplierFinal;

      this.addPopsToQueue(
        winningLineEvent,
        data.cascades[i].winAmount,
        leftMultiplierInc,
        rightMultiplierInc,
        leftMultiplierFinal,
        rightMultiplierFinal,
        isCapped,
        false
      );
      this.addDropsToQueue(
        data.cascades[i + 1].finalStopWindow.reelList,
        data.cascades[i + 1].wildAddedCoord,
        poppedSymbols,
        specialReward,
        trailCount,
        leftMultiplierInc,
        rightMultiplierInc,
        leftMultiplierFinal,
        rightMultiplierFinal,
        extraLives,
        extraWildCoord
      );
    } else {
      this.addPopsToQueue(
        winningLineEvent,
        data.cascades[i].winAmount,
        leftMultiplierInc,
        rightMultiplierInc,
        leftMultiplierFinal,
        rightMultiplierFinal,
        isCapped,
        true
      );
    }

    //serverWindow, wildCells, poppedSymbols, specialReward, trailCount, leftMultiplierInc, rightMultiplierInc, leftMultiplierFinal, rightMultiplierFinal, extraLives
  }
  //this.fsCount ++

  if (isNotFinal) {
    /**
     * Tnt modifier in cascades
     */
    for (let i = 0; i < this._messageQueue.length; i++) {
      if (this._messageQueue[i].tntModifier !== undefined) {
        if (this._messageQueue[i].tntModifier.isAwarded) {
          let fakeSymbols =
            this._messageQueue[i].tntModifier.replacementSymbols;
          let fakeSymbolsLength =
            this._messageQueue[i].tntModifier.replacementSymbols.length;
          let reel = this._messageQueue[i].tntModifier.reelToHide;
          let dropMessage = this._messageQueue[i - 3]; // get the drop modifier event

          for (let j = 0; j < fakeSymbolsLength; j++) {
            for (let j = 0; j < fakeSymbolsLength; j++) {
              if (dropMessage.window !== undefined) {
                dropMessage.window[reel][j]._id = fakeSymbols[j];
              } else if (dropMessage.resultPanel.reelList !== undefined) {
                dropMessage.resultPanel.reelList[reel].symbols[j].value =
                  fakeSymbols[j];
              }
            }
          }
        }
      }
    }
  }

  this.fsWinnings += spinWin;
  this.addPopDropsOverToQueue(spinWin, isCapped);

  if (this.fsCount < this.freeSpins.length) {
    this.addFSDataToQueue();
  } else {
    this.addFSEndToQueue(isCapped);
    this.addGameCompleteToQueue(this.fsWinnings);
    this.inFS = false;
    this.numFsRemaining = 0;
  }

  cb();

  this.triggerNextMessage();
};

GatiServerGame.prototype.sendGambleResponseToServer = function (
  numScatters,
  response,
  cb
) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate("Gamble:HandledCommand");
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;
  let nextStep =
    self._latestEngineReponse.wager.bets[
      self._latestEngineReponse.wager.bets.length - 1
    ].step + 1;
  let commands =
    self._latestEngineReponse.wager.bets[
      self._latestEngineReponse.wager.bets.length - 1
    ].betdata.cmds;
  let command;

  if (response === "gamble") {
    command = commands[1];
  } else {
    command = commands[0];
  }

  let playData = {
    cmd: command,
    step: nextStep,
    clientParams: "",
  };

  if (this._forces) {
    this.addCheatToRequest(playData, this._forces);
  }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);
    cb();
  };

  sendCommand();
};

GatiServerGame.prototype.addFSAwardToQueue = function (data) {
  let numFS = [7, 9, 11, 16];
  let numScatters;

  if (data.spinsCountOnWin === 16) {
    data.spinsCount = 11;
    numScatters = 4;
  } else if (data.spinsCountOnWin === 11) {
    data.spinsCount = 9;
    numScatters = 3;
  } else if (data.spinsCountOnWin === 9) {
    data.spinsCount = 7;
    numScatters = 2;
  }

  var message = {};
  message.type = "game:FreeSpinsAwardEvent";
  message.freeSpinsAwarded = numFS[numScatters - 3];
  message.possibleValues = numFS;
  message.numScatters = numScatters;
  message.nextFreespins = numFS[numScatters - 2];
  message.winChance = data.winChance;
  message.loseChance = data.loseChance;
  message.buyABonus = this._inBuyABonus;
  message.buyASuperBonus = this._inBuyASuperBonus;
  message.numFreeSpins = data.spinsCount;
  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(numScatters, obj.response, cb);
  };

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleResultToQueue = function (won) {
  var message = {};
  message.type = "fire_gems:GambleResultEvent";
  message.won = won;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inFS) {
    this.getSpinDataFS(cb, data);
    return;
  }

  let parts = data.Parts;

  let totalWon = 0;
  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    if (type === "baseGame") {
      this._finalBaseWinnings = parts[0].winAmount;
      totalWon += this.getSpinDataNormal(parts[i]);
      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === "gambleEntered") {
      if (parts[i].spinsCount >= 13) {
        // nothing to gamble for

        this.addFSAwardToQueue(parts[i]);
        this.inGamble = true;
      } else {
        this.addFSAwardToQueue(parts[i]);
        this.inGamble = true;
      }
    } else if (type === "gambleResult") {
      let won = parts[i].hasWon;
      this.addGambleResultToQueue(won);
      if (!won) {
        this.inGamble = false;
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === "freeSpins") {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = data.Parts[0].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;
      this.addFSStartToQueue(parts[i].spins.length);
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addPopsToQueue = function (
  winningsLinesMessage,
  winAmount,
  leftMultiplierInc,
  rightMultiplierInc,
  leftMultiplierFinal,
  rightMultiplierFinal,
  isCapped,
  isFinalCapped
) {
  var message = winningsLinesMessage;
  message.type = "spinner:WinningLinesEvent";
  message.totalLineWinnings = winAmount;

  message.leftMultiplierInc = leftMultiplierInc;
  message.rightMultiplierInc = rightMultiplierInc;
  message.leftMultiplierFinal = leftMultiplierFinal;
  message.rightMultiplierFinal = rightMultiplierFinal;

  message.isCapped = isCapped;
  message.isFinalCapped = isFinalCapped;

  let waysTypes = ["payWaysLeft", "payWaysRight", "payWays5X"];

  // let message = {};
  // message.wins = event;
  // message.type = "spinner:WinningLinesEvent";

  //THREE TIMES FOR EACH WAY : spinData[i].payWaysLeft.payWaysWins, spinData[i].finalStopWindow.reelList

  const wildID = 12;
  for (let typeIdx = 0; typeIdx < waysTypes.length; typeIdx++) {
    for (let i = 0; i < message[waysTypes[typeIdx]].payWaysWins.length; ++i) {
      let winData = message[waysTypes[typeIdx]].payWaysWins[i];

      // this winning symbol id
      let winSymbolId = winData.symbol;

      // an array of all winning symbols in this win (including wilds)
      winData.winSymPositions = [];

      // loop through all reels
      for (let reel = 0; reel < 5; reel++) {
        let found = false;

        // symbols on this reel
        let reelList = message.finalStopWindow.reelList[reel];

        // loop through all currently active symbols on this reel
        for (let row = 0; row < 3; row++) {
          // symbol on reel
          let symID = reelList.symbols[row].value;

          for (let i = 0; i < winData.coords.length; i++) {
            if (
              winData.coords[i].reel === reel &&
              winData.coords[i].row === row
            ) {
              //check it's a winning symbol
              // is it symbol we are looking for or a wild
              if (symID === winSymbolId) {
                //found = true; // we can continue to next reel
                // store its position

                //for(winData.coords)
                winData.winSymPositions.push({
                  reel: reel,
                  row: row,
                  sym: symID,
                });
              }

              if (symID === wildID) {
                winData.winSymPositions.push({
                  reel: reel,
                  row: row,
                  sym: wildID,
                });
              }
            }
          }
          // // is it symbol we are looking for or a wild
          // if (symID === winSymbolId){
          // 	//found = true; // we can continue to next reel
          // 	// store its position

          // 	//for(winData.coords)
          // 	winData.winSymPositions.push({reel: reel, row: row, sym: symID});
          // }

          // if(symID === wildID){
          // 	winData.winSymPositions.push({reel: reel, row: row, sym: wildID});
          // }
          // no symbols found (including wilds) so do not continue to next reel as they need to be consecutive
          // if (!found){
          // 	break;
          // }
        }
      }
    }
  }

  // loop through all winning symbols

  this._messageQueue.push(message);
  //message.winningSymbols = winningSymbols;

  //this.gameOutcome.outcomeWinnings;
  //message.totalLineWinningsNonMultiplied = unMultiplied;

  //this._messageQueue.push(message);
};

GatiServerGame.prototype.addDropsToQueue = function (
  serverWindow,
  wildCells,
  poppedSymbols,
  specialReward,
  trailCount,
  leftMultiplierInc,
  rightMultiplierInc,
  leftMultiplierFinal,
  rightMultiplierFinal,
  extraLives,
  extraWild
) {
  var popWindow = [
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
  ];

  for (let i = 0; i < poppedSymbols.length; ++i) {
    let cell = poppedSymbols[i];
    popWindow[cell.reel][cell.row] = -1;
  }

  if (wildCells !== null) {
    popWindow[wildCells.reel][wildCells.row] = 0;
  }

  if (extraWild !== null && extraWild !== undefined) {
    extraWild.forEach((wild) => {
      popWindow[wild.reel][wild.row] = 0;
    });
  }

  let newWindow = [];

  for (let i = 0; i < serverWindow.length; ++i) {
    let slot = [];
    let serverSlot = serverWindow[i].symbols;
    for (j = 0; j < serverSlot.length; ++j) {
      slot.push({ _id: serverSlot[j].value });
    }

    newWindow.push(slot);
  }

  var message = {};
  message.type = "game:DropEvent";
  message.tumbleData = popWindow;
  message.window = newWindow;
  message.cells = wildCells;
  message.trailCount = trailCount;
  message.specialReward = specialReward;
  message.leftMultiplierInc = leftMultiplierInc;
  message.rightMultiplierInc = rightMultiplierInc;
  message.leftMultiplierFinal = leftMultiplierFinal;
  message.rightMultiplierFinal = rightMultiplierFinal;
  message.extraLivesFinal = extraLives;
  message.extraWild = extraWild;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addModifierEventToQueue = function (
  data,
  reelListAfterPop,
  winningLineEvent
) {
  var message = {};
  message.type = "game:ModifierEvent";
  message.reelToHide = data.reelToHide;
  message.winningLineEvent = winningLineEvent;
  let symbols = [];

  for (let i = 0; i < data.replacementSymbols.length; i++) {
    symbols.push({
      reel: data.reelToHide,
      row: i,
      newSyms: data.replacementSymbols[i],
      reelToHide: data.reelToHide,
    });
  }

  this._messageQueue.push(message);

  this.addDropsToQueue(reelListAfterPop, null, symbols, []); //serverWindow, wildCells, poppedSymbols, specialReward
};

GatiServerGame.prototype.addPopDropsOverToQueue = function (
  winnings,
  isCapped
) {
  var message = {};
  message.type = "game:PopAndDropComplete";
  message.winnings = winnings;
  message.isCapped = isCapped;
  message.totalWinnings = this._finalBaseWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSStartToQueue = function (numFs) {
  this.fsWinnings = 0;
  var message = {};
  message.type = "game:FreeSpinsStartEvent";
  message.freeSpinsAwarded = numFs;
  message.bonuswin = 0;
  message.currentMultiplier = 1;
  message.nextMultiplier = 2;
  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  var message = {};
  message.type = "game:FreeSpinsDataEvent";
  message.num = this.numFsRemaining;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (isCapped) {
  var message = {};
  message.type = "game:FreeSpinsEndEvent";
  message.fsWinnings = this.fsWinnings;
  message.finalFsWinnings = this._finalFsWinnings;
  message.totalWinnings = this._totalWinnings;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};
